export default __webpack_public_path__ + "static/media/KOD0125-min.545b4468.webp";